jQuery( 'body' ).ready( function ( $ ) {  
    if ($(".support-model-slider-mobile").length > 0) {
      $(".support-model-slider-mobile").slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              dots: true,
              arrows: false,
              infinite: true,
              autoplay: true,
              autoplaySpeed: 4000,
              slidesToShow: 1,
              slidesToScroll: 1
            },
          },
        ],
      });
    } 

    if ($(".slick-content-cross-platform").length > 0) {
      $(".slick-content-cross-platform").slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        prevArrow: $(".expertise-icon-prev"),
        nextArrow: $(".expertise-icon-next"),
        responsive: [
          {
            breakpoint: 480,
            settings: {
              prevArrow: false,
              nextArrow: false,
              dots: true,
              arrows: false,
              infinite: true,
              autoplay: false,
              autoplaySpeed: 4000,
              slidesToShow: 1,
              slidesToScroll: 1,
              rows: 1,
              vertical: false,
              verticalSwiping: false,
              adaptiveHeight: true,
              centerMode: true,
              centerPadding: false
            },
          },
        ],
      });
    }       
  });